/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} User_Detail_Vp_Per_GameInputs */



/**
* | output |
* | --- |
* | "VP per game: {value}" |
*
* @param {User_Detail_Vp_Per_GameInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_vp_per_game = /** @type {((inputs: User_Detail_Vp_Per_GameInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_Vp_Per_GameInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`VP par partie : ${i?.value}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`VP por partida: ${i?.value}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`VP por partida: ${i?.value}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`VP per partita: ${i?.value}`)
	return /** @type {LocalizedString} */ (`VP per game: ${i?.value}`)
});